/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Category } from '../model/category';
import { HubService } from '../model/hubService';
import { ProblemDetails } from '../model/problemDetails';
import { ServiceProvidersDtoo } from '../model/serviceProvidersDtoo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SqlDataMigrationService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetAddressBookContactGet(observe?: 'body', reportProgress?: boolean): Observable<Array<HubService>>;
    public apiSqlDataMigrationGetAddressBookContactGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubService>>>;
    public apiSqlDataMigrationGetAddressBookContactGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubService>>>;
    public apiSqlDataMigrationGetAddressBookContactGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubService>>('get',`${this.basePath}/api/SqlDataMigration/GetAddressBookContact`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetAddressBookGet(observe?: 'body', reportProgress?: boolean): Observable<Array<HubService>>;
    public apiSqlDataMigrationGetAddressBookGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubService>>>;
    public apiSqlDataMigrationGetAddressBookGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubService>>>;
    public apiSqlDataMigrationGetAddressBookGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubService>>('get',`${this.basePath}/api/SqlDataMigration/GetAddressBook`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetAreasGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProvidersDtoo>>;
    public apiSqlDataMigrationGetAreasGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetAreasGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetAreasGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceProvidersDtoo>>('get',`${this.basePath}/api/SqlDataMigration/GetAreas`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetCategoriesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Category>>;
    public apiSqlDataMigrationGetCategoriesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Category>>>;
    public apiSqlDataMigrationGetCategoriesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Category>>>;
    public apiSqlDataMigrationGetCategoriesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Category>>('get',`${this.basePath}/api/SqlDataMigration/GetCategories`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetHubServicesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<HubService>>;
    public apiSqlDataMigrationGetHubServicesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubService>>>;
    public apiSqlDataMigrationGetHubServicesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubService>>>;
    public apiSqlDataMigrationGetHubServicesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubService>>('get',`${this.basePath}/api/SqlDataMigration/GetHubServices`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetIndustriesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProvidersDtoo>>;
    public apiSqlDataMigrationGetIndustriesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetIndustriesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetIndustriesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceProvidersDtoo>>('get',`${this.basePath}/api/SqlDataMigration/GetIndustries`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetShortCodeServiceProviderMapGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProvidersDtoo>>;
    public apiSqlDataMigrationGetShortCodeServiceProviderMapGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetShortCodeServiceProviderMapGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetShortCodeServiceProviderMapGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceProvidersDtoo>>('get',`${this.basePath}/api/SqlDataMigration/GetShortCodeServiceProviderMap`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetShortCodesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceProvidersDtoo>>;
    public apiSqlDataMigrationGetShortCodesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetShortCodesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceProvidersDtoo>>>;
    public apiSqlDataMigrationGetShortCodesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceProvidersDtoo>>('get',`${this.basePath}/api/SqlDataMigration/GetShortCodes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSqlDataMigrationGetVasProviderRolesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Category>>;
    public apiSqlDataMigrationGetVasProviderRolesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Category>>>;
    public apiSqlDataMigrationGetVasProviderRolesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Category>>>;
    public apiSqlDataMigrationGetVasProviderRolesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Category>>('get',`${this.basePath}/api/SqlDataMigration/GetVasProviderRoles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
